class ProductTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('.product-tabs__tab'));
    this.panels = Array.from(this.querySelectorAll('.product-tabs__panel'));

    if (!this.tabs.length) return;

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activate(tab.dataset.tabTarget));
    });

    this.activate(this.tabs[0].dataset.tabTarget);
  }

  activate(targetId) {
    this.tabs.forEach((tab) => {
      const active = tab.dataset.tabTarget === targetId;
      tab.setAttribute('aria-selected', String(active));
    });

    this.panels.forEach((panel) => {
      const active = panel.dataset.tabPanel === targetId;
      panel.hidden = !active;
    });
  }
}

if (!customElements.get('product-tabs-component')) {
  customElements.define('product-tabs-component', ProductTabs);
}
